<!-- =========================================================================================
    File Name: TableMiscellaneous.vue
    Description: Combine filter,sorter, pagination etc.
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card title="Shipment" id="account-manage-buttons">
    <div>
      <vs-alert
        :active.sync="alert_success"
        closable
        :color="color"
        icon-pack="feather"
        close-icon="icon-x"
        v-if="alert_success"
      >
        {{ message_success }}
      </vs-alert>
    </div>
    <br />
    <div v-if="!uploadResi">
      <div class="vx-row">
        <div class="vx-col sm:w-9/12 w-full">
          <!-- Append Button -->

          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="dropdown-button-container">
                <vs-dropdown>
                  <vs-button class="btn-drop" type="filled" icon="expand_more"
                    >Search By
                    {{
                      search_by == 1 ? "Receipt Number" : "Invoice Number"
                    }}</vs-button
                  >
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="search_by = 1">
                      By Receipt Number
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="search_by = 2">
                      By Invoice Number
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </template>
            <vs-input v-model="search" />

            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button color="primary" @click="resetPage">Search</vs-button>
              </div>
            </template>
          </vx-input-group>
        </div>
        <div class="vx-col sm:w-3/12 w-full">
          <div class="dropdown-button-container">
            <vs-dropdown>
              <vs-button
                class="btn-drop"
                type="filled"
                icon="expand_more"
                color="success"
              >
                {{
                  status == null
                    ? "Status All"
                    : "Status " + changeStatus(status)
                }}</vs-button
              >
              <vs-dropdown-menu>
                <vs-dropdown-item @click="status = null">All</vs-dropdown-item>
                <vs-dropdown-item @click="status = 0">
                  {{ changeStatus(0) }}
                </vs-dropdown-item>
                <vs-dropdown-item @click="status = 1">
                  {{ changeStatus(1) }}
                </vs-dropdown-item>
                <vs-dropdown-item @click="status = 2">
                  {{ changeStatus(2) }}
                </vs-dropdown-item>
                <vs-dropdown-item @click="status = 3">
                  {{ changeStatus(3) }}
                </vs-dropdown-item>
                <vs-dropdown-item @click="status = 9">
                  {{ changeStatus(9) }}
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>
        <!-- /Append Button -->
      </div>
      <div v-if="load == 1">
        <br />
        <h5>Load data ....</h5>
      </div>
      <vs-table
        v-model="selected"
        stripe
        :data="shipments"
        id="button-with-loading"
        v-else
      >
        <template slot="thead">
          <vs-th sort-key="title">Transaksi</vs-th>
          <vs-th sort-key="description">Price</vs-th>
          <vs-th sort-key="requirement">Promocode</vs-th>
          <vs-th sort-key="requirement">Detail</vs-th>
          <vs-th sort-key="requirement">Status</vs-th>
          <vs-th sort-key="title">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.store_transaction.code }}</vs-td>
            <vs-td>{{ tr.store_transaction.price }}</vs-td>

            <vs-td :data="tr.promo_code">{{ tr.order.promo_code }}</vs-td>
            <vs-td :data="tr.account_number"
              ><vs-button
                @click="setPopUp(tr)"
                color="primary"
                icon-pack="feather"
                icon="icon-search"
              ></vs-button
            ></vs-td>
            <vs-td :data="tr.status">{{ setStatus(tr.status) }}</vs-td>
            <vs-td :data="tr.status" v-if="tr.status != 3 && tr.status != 9">
              <vs-dropdown
                vs-trigger-click
                class="ml-auto md:block hidden cursor-pointer"
              >
                <vs-button icon="icon-settings" icon-pack="feather"></vs-button>
                <vs-dropdown-menu
                  class="w-32"
                  v-if="tr.status != 9 || tr.status != 4"
                >
                  <vs-dropdown-item v-if="tr.status < 1">
                    <div
                      @click="uploadShipment(tr.id)"
                      class="flex items-center"
                    >
                      <span>Upload Resi Number</span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="tr.status < 2">
                    <div
                      @click="checkShipment(tr.id)"
                      class="flex items-center"
                    >
                      <span>Check Shipment</span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="tr.status < 3">
                    <div
                      @click="confirmShipment(tr.id)"
                      class="flex items-center"
                    >
                      <span>Confirm Shipment</span>
                    </div>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <br />
      <template>
        <vs-pagination :total="20" v-model="page" :max="10"></vs-pagination>
      </template>
      <template>
        <div class="demo-alignment">
          <vs-popup
            fullscreen
            title="Detail Shipment"
            :active.sync="popupActive"
          >
            <div
              class="vx-col w-full"
              v-for="product in popUpData.products"
              :key="product.id"
            >
              <div class="vx-row margin-custom">
                <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base md:mt-0">
                  <h3 class="text-black">Product</h3>

                  <table>
                    <tr>
                      <td>Name</td>
                      <td>: {{ product.name }}</td>
                    </tr>
                    <tr>
                      <td>Price</td>
                      <td>: {{ product.price }}</td>
                    </tr>
                    <tr>
                      <td>Quantity</td>
                      <td>: {{ product.total }}</td>
                    </tr>
                    <tr>
                      <td>Color</td>
                      <td>: {{ product.color }}</td>
                    </tr>
                    <tr>
                      <td>Size</td>
                      <td>: {{ product.size }}</td>
                    </tr>
                    <tr>
                      <td>Note</td>
                      <td>: {{ product.note }}</td>
                    </tr>
                  </table>
                </div>
                <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base md:mt-0">
                  <img
                    v-bind:src="product.photo"
                    alt=""
                    class="rounded"
                    width="200"
                  />
                </div>
              </div>
            </div>
            <div class="vx-col w-full" v-if="popUpData.courier">
              <div class="vx-row margin-custom">
                <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base md:mt-0">
                  <h3 class="text-black">Courier</h3>

                  <table>
                    <tr>
                      <td>Receipt Number</td>
                      <td>: {{ popUpData.receipt_number }}</td>
                    </tr>
                    <tr>
                      <td>Price</td>
                      <td>: {{ popUpData.price }}</td>
                    </tr>
                    <tr>
                      <td>Weight</td>
                      <td>: {{ popUpData.weight }}</td>
                    </tr>
                    <tr>
                      <td>Note</td>
                      <td>: {{ popUpData.note }}</td>
                    </tr>
                    <tr>
                      <td>Delivery Date</td>
                      <td>: {{ popUpData.delivery_date }}</td>
                    </tr>
                    <tr>
                      <td>Receive Date</td>
                      <td>: {{ popUpData.received_date }}</td>
                    </tr>
                    <tr>
                      <td>Courier Name</td>
                      <td>: {{ popUpData.courier.name }}</td>
                    </tr>
                    <tr>
                      <td>Courier Service</td>
                      <td>: {{ popUpData.courier.service }}</td>
                    </tr>
                    <tr>
                      <td>Courier Price</td>
                      <td>: {{ popUpData.courier.value }}</td>
                    </tr>
                    <tr>
                      <td>Estimated</td>
                      <td>: {{ popUpData.courier.etd }}</td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td>: {{ setStatus(popUpData.status) }}</td>
                    </tr>
                  </table>
                </div>
                <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base md:mt-0">
                  <h3 class="text-black">Address</h3>

                  <table>
                    <tr>
                      <td>Province</td>
                      <td>: {{ popUpData.address.province_name }}</td>
                    </tr>
                    <tr>
                      <td>City</td>
                      <td>: {{ popUpData.address.city_name }}</td>
                    </tr>
                    <tr>
                      <td>District</td>
                      <td>: {{ popUpData.address.district_name }}</td>
                    </tr>
                    <tr>
                      <td>Pos Code</td>
                      <td>: {{ popUpData.address.zip_code }}</td>
                    </tr>
                    <tr>
                      <td>Detail</td>
                      <td>: {{ popUpData.address.detail }}</td>
                    </tr>
                    <tr>
                      <td>Receiver Name</td>
                      <td>: {{ popUpData.address.receiver_name }}</td>
                    </tr>
                    <tr>
                      <td>Receiver Phone</td>
                      <td>: {{ popUpData.address.receiver_phone }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </vs-popup>
        </div>
      </template>
    </div>
    <div v-else>
      <form @submit.prevent="onSubmitResi" id="account-manage-buttons">
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Input Resi</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              name="Password"
              class="w-full"
              v-model="resi_number"
              required
            />
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="flex flex-wrap items-center justify-end">
          <vs-button
            class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
            button="submit"
            >Submit</vs-button
          >
        </div>
      </form>
    </div>
  </vx-card>
</template>
   

<script>
import axios from '../../../axios110'
import Prism from 'vue-prism-component'
import moment from 'moment'
import vSelect from 'vue-select'
export default {
  data() {
    return {
      'selected': [],
      'tableList': [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      'payments': [],
      'shipments': [],
      'colorAlert': 'primary',
      'titleAlert': 'Alert',
      'activeAlert': false,
      'valueInput': '',
      userAuth: this.$store.state.user,
      'deleteId': null,
      popupActive: false,
      popUpData: [],
      uploadResi: false,
      resi_number: '',
      resi_shipment_id: '',
      page: 1,
      limit: 10,
      oldData: [],
      active1: true,
      alert_success: false,
      message_success: '',
      color: 'success',
      search: '',
      search_by: 1,
      status: null,
      load: 1,

    }
  },
  components: {
    'v-select': vSelect,
  },
  watch: {
    status(newValue, oldValue) {
      this.resetPageStatus()

    },
    page(newValue, oldValue) {
      this.getShipment()

    },




  },
  mounted() {
    this.popupActive = false
    this.getShipment()

  },
  methods: {
    setPopUp(tr) {

      this.popupActive = true
      this.popUpData = tr
      console.log(this.popUpData)

    },
    resetPageStatus() {
      this.resetPage()
    },
    resetPage() {
      this.page = 1
      this.getShipment()
    },
    onSubmitResi() {
      const formData = {
        id: this.resi_shipment_id,
        receipt_number: this.resi_number,

      }

      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#account-manage-buttons",
        scale: 0.45
      })
      axios.put('ecommerce/web/shipment/receipt', formData)
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
            //   this.errorRecover = true
            //   this.messageRecover = 'Email tidak terdaftar!'
          } else {
            this.uploadResi = false
            this.resi_number = ''
            this.resi_shipment_id = ''
            this.alert_success = true
            this.message_success = 'Success upload receipt number'
            this.color = 'success'
            this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
            this.getShipment()




          }


        })
        .catch(error => {
          console.log(error.response)

          this.uploadResi = true
          this.alert_success = true
          this.message_success = 'The receipt number already taken'
          this.color = 'warning'
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")


        })




    },

    uploadShipment(id) {
      this.resi_shipment_id = id
      this.uploadResi = true

    },

    checkShipment(id) {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#account-manage-buttons",
        scale: 0.45
      })
      axios.get('ecommerce/web/shipment/check/' + id, {})
        .then(res => {

          console.log(res)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('success', 'Congrats', 'Shipment status ' + res.data.status)
        })
        .catch(error => {
          console.log(error.response)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('warning', 'Sorry', error.response.data.message)
        })


    },
    confirmShipment(id) {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#account-manage-buttons",
        scale: 0.45
      })
      axios.put('ecommerce/web/shipment/confirm/' + id, {})
        .then(res => {

          console.log(res)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('success', 'Congrats', 'Success confirm shipment ')
          this.getShipment()
        })
        .catch(error => {
          console.log(error.response)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('warning', 'Sorry', 'Something wrong')
        })


    },
    changeStatus(status) {
      if (status == 0) {
        return 'New'
      }
      if (status == 1) {
        return 'Waiting'
      }
      if (status == 2) {
        return 'Delivered'
      }
      if (status == 3) {
        return 'Confirmed'
      }
      if (status == 9) {
        return 'Cancel'
      }

    },
    getShipment() {
      this.load = 1
      this.shipments = []
      let statusParam = this.status == null ? '' : '&status=' + this.status
      let search_type = this.search_by == 1 ? '&receipt_number=' + this.search : '&code=' + this.search
      let searchParam = this.search ? search_type : ''
      axios.get(`/ecommerce/web/shipment/by_store/${this.userAuth.company.id}?limit=` + this.limit + '&page=' + this.page + searchParam + statusParam, {})
        .then(res => {

          console.log(res)
          this.shipments = res.data.data

          this.alert_success = false
          this.load = 0

        })
        .catch(error => {
          console.log(error.response)
          this.load = 0
        })


    },
    setStatus(status) {
      if (status == 0) {
        return 'New'
      }
      if (status == 1) {
        return 'Waiting'
      }
      if (status == 2) {
        return 'Delivered'
      }
      if (status == 3) {
        return 'Confirmed'
      }
      if (status == 9) {
        return 'Cancel'
      }

    },
    checkStore(id) {
      if (this.userAuth.company.id == id) {
        return 1
      }
      else {
        return 0
      }

    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    limitChar(str) {
      var output = ''
      if (str.length > 100) {
        str = str.substring(0, 100)
        output = str + '...'
      } else {
        output = str
      }
      return output
    },
    deleteAlert(color, id) {
      this.colorAlert = color
      this.deleteId = id
      console.log(`masuk delete${this.deleteId}`)
      this.$vs.dialog({
        color: this.colorAlert,
        title: 'Apa anda yakin?',
        text: 'Setelah dihapus data ini tidak bisa diakses lagi',
        accept: this.deletePaymentAccount
      })
    },


    editPaymentAccount(id) {
      console.log(id)
      this.$router.push(`/paymentAccount/edit/${id}`)
    },
    handleSelected(tr) {
      this.$router.push(`/payment/${tr.id}/applicant`)
    },
    acceptAlert(color, title, message) {

      this.$vs.notify({
        color,
        title,
        text: message
      })

    },

  },
  components: {
    Prism
  }
}
</script>
